import { FoodBeverageContactType } from '@api';
import {
  ContactPersonAnchor,
  getValueByPath,
  TouringCardTableRow,
  TouringCardTableRowLabel,
  TouringCardTableRowValue,
} from '@common';
import { useTranslation } from 'react-i18next';
import { VenueFoodBeverageContactTableRowType } from '../../data';

type VenueFoodBeverageContactTableRowPropsType = {
  venueFoodBeverageContact: FoodBeverageContactType;
  row: VenueFoodBeverageContactTableRowType;
};
export const VenueFoodBeverageContactTableRow: React.FC<
  VenueFoodBeverageContactTableRowPropsType
> = ({ venueFoodBeverageContact, row }) => {
  const { t } = useTranslation('venueDetailsOverview');

  const label = t(`VENUE_FOOD_BEVERAGE_CONTACT.ROWS.${row.label}`);
  const value = getValueByPath(venueFoodBeverageContact, row.accessor);

  const getRenderValue = () => {
    if (!value) return t('NO_DATA_PLACEHOLDER', { ns: 'common' });

    switch (row.accessor) {
      case 'contact':
        if (typeof value === 'string') return null;
        return <ContactPersonAnchor contactPerson={value} />;
      case 'notes':
        return String(value);
    }
  };
  return (
    <TouringCardTableRow>
      <TouringCardTableRowLabel>{label}</TouringCardTableRowLabel>
      <TouringCardTableRowValue>{getRenderValue()}</TouringCardTableRowValue>
    </TouringCardTableRow>
  );
};
